import React, { useEffect, useRef, useState } from "react";

const ActiveEmiInfo = (props) => {
  const infoForm = useRef(null);
  const [revenueInfoData, setRevenueInfoData] = useState({});
  const [timeline, setTimeline] = useState("TODAY");
  const [searchdata, setSearchdata] = useState({});
  const revenueInfoCardData = [
    {
      title: "Total Collections",
      count: revenueInfoData?.totalCollection?.repaymentCount || 0,
      amount: revenueInfoData?.totalCollection?.repaymentAmt || 0,
      icon: imagepaths.dollarCollectionIcon,
      path: `/app/portfolioinfo?cardname=totalCollection&timeline=${searchdata?.startDate ? "CUSTOM" : timeline
        }&tablename=collections&startDate=${searchdata?.startDate || null
        }&endDate=${searchdata?.endDate || null}`,
    },
    {
      title: "Processing Fees",
      count: revenueInfoData?.revenueProcessingFees?.processingFeeCount || 0,
      amount: revenueInfoData?.revenueProcessingFees?.processingFeeAmt || 0,
      icon: imagepaths.dollarBagIcon,
      path: `/app/portfolioinfo?cardname=processingFees&timeline=${searchdata?.startDate ? "CUSTOM" : timeline
        }&startDate=${searchdata?.startDate || null}&endDate=${searchdata?.endDate || null
        }`,
    },
    {
      title: "Principle",
      count: revenueInfoData?.revenuePrinciple?.principleCount || 0,
      amount: revenueInfoData?.revenuePrinciple?.principleAmt || 0,
      icon: imagepaths.coinStackIcon,
      path: `/app/portfolioinfo?cardname=principle&timeline=${searchdata?.startDate ? "CUSTOM" : timeline
        }&startDate=${searchdata?.startDate || null}&endDate=${searchdata?.endDate || null
        }`,
    },
    {
      title: "Actual Interest Earned",
      count: revenueInfoData?.revenueInterest?.interestCount || 0,
      amount: revenueInfoData?.revenueInterest?.interestAmt || 0,
      icon: imagepaths.percentageRoundedIcon,
      path: `/app/portfolioinfo?cardname=interest&timeline=${searchdata?.startDate ? "CUSTOM" : timeline
        }&startDate=${searchdata?.startDate || null}&endDate=${searchdata?.endDate || null
        }`,
    },
    {
      title: "GST",
      count: revenueInfoData?.revenueGST?.gstCount || 0,
      amount: revenueInfoData?.revenueGST?.gstAmt || 0,
      icon: imagepaths.percentageRoundedIcon,
      path: `/app/portfolioinfo?cardname=gst&timeline=${searchdata?.startDate ? "CUSTOM" : timeline
        }&tablename=gst&startDate=${searchdata?.startDate || null}&endDate=${searchdata?.endDate || null
        }`,
    }
  ];
  // REVENUE INFO

  const getRevenueInfo = (query, params) => {
    let data = {
      ...query,
      timeline: params || timeline,
    };

    let payload = {};
    console.log({ data, payload, params });
    props.apis.apiGetAdminDashboardRevenueAndDisbursement(data, payload).then((res) => {
      let revenueData = {
        totalCollection: {
          repaymentCount: res?.revenue?.collections?.count,
          repaymentAmt: res?.revenue?.collections?.amount,
        },
        revenueProcessingFees: {
          processingFeeCount: res?.revenue?.processingFees?.count,
          processingFeeAmt: res?.revenue?.processingFees?.amount,
        },
        revenuePrinciple: {
          principleCount: res?.revenue?.principal?.count,
          principleAmt: res?.revenue?.principal?.amount,
        },
        revenueInterest: {
          interestCount: res?.revenue?.interest?.count,
          interestAmt: res?.revenue?.interest?.actualInterestEarned,
        },
        revenueGST: {
          gstCount: res?.revenue?.gst?.count,
          gstAmt: res?.revenue?.gst?.amount,
        },
      };
      setRevenueInfoData(revenueData);
    });
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
        }
      });
    }
  };

  const handleDateChange = (value) => {
    let val = value[0]?.key || "TODAY";
    let inputs = [
      "revenue-column-startDate",
      "revenue-column-endDate",
      "revenue-column-search_btn",
      "revenue-column-reset_btn",
    ];
    console.log({ val });
    props.onTimelineChange(val);
    if (val === "CUSTOM") {
      showInputs(inputs);
      setRevenueInfoData({});
    } else {
      hideInputs(inputs);
      setTimeline(val);
    }
  };

  const onSearch = () => {
    let data = infoForm.current.form.current.getData();
    let queryData = {
      ...Object.except(data, ["timeline"]),
    };
    props.onCustomTimelineChange(queryData);
    setSearchdata(queryData);
    getRevenueInfo(queryData, "CUSTOM");
  };

  const resetSearchForm = () => {
    infoForm?.current?.form?.current?.reset();
    let inputs = [
      "revenue-column-startDate",
      "revenue-column-endDate",
      "revenue-column-search_btn",
      "revenue-column-reset_btn",
    ];
    props.onCustomTimelineChange({});
    hideInputs(inputs);
    getRevenueInfo({}, "TODAY");
  };

  useEffect(() => {
    getRevenueInfo({}, timeline);
  }, [timeline]);

  props.$setNode({
    props,
    revenueInfoData,
  });
  return (
    <>
      <div className="mb-4 dashboard_form_box">
        <div className="form_outer">
          <AppForm
            ref={infoForm}
            onSubmit={(...args) => onSearch(...args)}
            className="row justify-content-end"
          >
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2"
              id="column-timeline"
            >
              <AppInputFocus
                type="select"
                name="timeline"
                label="Time Line"
                options={_enum.OVERALL_DETAIL}
                onChange={(...args) => handleDateChange(...args)}
                defaultValue={"TODAY"}
                placeholder="Time Line"
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="revenue-column-startDate"
            >
              <AppInputFocus
                type="date"
                name="startDate"
                label="Start Date"
                placeholder="Start Date"
                required={true}
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="revenue-column-endDate"
            >
              <AppInputFocus
                type="date"
                name="endDate"
                label="End Date"
                placeholder="End Date"
                required={true}
              ></AppInputFocus>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="revenue-column-search_btn"
            >
              <button type="submit" className="btn btn-primary search_btn">
                <i className="fa fa-search"></i>
                <span>Search</span>
              </button>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="revenue-column-reset_btn"
            >
              <button
                type="button"
                className="btn btn-primary search_btn"
                onClick={(...args) => resetSearchForm(...args)}
              >
                <i class="fa-solid fa-filter-circle-xmark"></i>
                <span>Reset</span>
              </button>
            </div>
          </AppForm>
        </div>
        <div className="row pt-0 pt-md-4">
          {revenueInfoCardData &&
            revenueInfoCardData.map((revenue) => {
              return (
                <>
                  <div
                    className="col-xl-3 col-sm-6"
                    onClick={(...args) => navigate(revenue?.path)}
                  >
                    <div className="card dashboard_card application_card revenue_info_card">
                      <div className="border_bottom_line"></div>
                      <div className="card-body">
                        <div className="icon_container">
                          <p className="icon_title">{revenue?.title}</p>
                          <div className="icon">
                            <img src={revenue?.icon} alt="icon image" />
                          </div>
                        </div>
                        <div className="content">
                          <p className="count">{revenue?.count}</p>
                          <p className="card_label">
                            Amount :{" "}
                            <span className="primary-red ms-1">
                              {revenue?.amount?.cur()}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default constore(ActiveEmiInfo);
